(function () {
  const root = document.querySelector('[data-discount-hunt]');
  if (!root) return;

  const api = root.dataset.apiBase || '/apps/discount-hunt';
  const account = root.querySelector('[data-hunt-account]');
  if (!account) return;

  const setup = root.querySelector('[data-hunt-setup]');
  const games = root.querySelector('[data-hunt-games]');
  const panel = root.querySelector('[data-hunt-panel]');
  const result = root.querySelector('[data-hunt-result]');
  const board = root.querySelector('[data-hunt-board]');
  const spendInput = root.querySelector('[data-hunt-spend]');
  const spendDecrease = root.querySelector('[data-hunt-spend-decrease]');
  const spendIncrease = root.querySelector('[data-hunt-spend-increase]');
  const error = root.querySelector('[data-hunt-error]');
  const chances = root.querySelector('[data-hunt-chances]');
  const orders = root.querySelector('[data-hunt-orders]');
  const lives = root.querySelector('[data-hunt-lives]');
  const title = root.querySelector('[data-hunt-title]');
  const description = root.querySelector('[data-hunt-description]');
  const gameIcon = root.querySelector('[data-hunt-game-icon]');
  const status = root.querySelector('[data-hunt-status]');
  const startButton = root.querySelector('[data-hunt-start]');
  const options = root.querySelector('[data-hunt-options]');
  const difficultyWrap = root.querySelector('[data-hunt-difficulty-wrap]');
  const difficulty = root.querySelector('[data-hunt-difficulty]');
  const difficultyTrigger = root.querySelector('[data-hunt-difficulty-trigger]');
  const difficultyLabel = root.querySelector('[data-hunt-difficulty-label]');
  const difficultyMenu = root.querySelector('[data-hunt-difficulty-menu]');
  const roundsWrap = root.querySelector('[data-hunt-rounds-wrap]');
  const rounds = root.querySelector('[data-hunt-rounds]');
  const discount = root.querySelector('[data-hunt-discount]');
  const copyButton = root.querySelector('[data-hunt-copy]');
  const againButton = root.querySelector('[data-hunt-again]');
  const muteButton = root.querySelector('[data-hunt-mute]');
  const muteIcon = root.querySelector('[data-hunt-mute-icon]');
  const unmutedIcon = root.querySelector('[data-hunt-unmuted-icon]');
  const mutedIcon = root.querySelector('[data-hunt-muted-icon]');
  let available = 0;
  let session = null;
  let activeLives = 0;
  let selectedGame = null;
  let cleanupGame = () => {};
  let isFinishing = false;
  let musicMuted = false;
  let musicAudio = null;

  function updateAvailabilityState() {
    const depleted = available <= 0;
    root.classList.toggle('is-depleted', depleted);
    games.querySelectorAll('[data-hunt-game]').forEach((button) => {
      button.disabled = depleted;
    });
    spendDecrease.disabled = depleted;
    spendIncrease.disabled = depleted;
    spendInput.disabled = depleted;
  }

  function startMusic(game) {
    stopMusic();
    const audioUrl = game === 'minesweeper' ? root.dataset.minesweeperAudio : root.dataset.concentrationAudio;
    if (!audioUrl) return;
    musicAudio = new Audio(audioUrl);
    musicAudio.loop = true;
    musicAudio.preload = 'auto';
    musicAudio.volume = musicMuted ? 0 : .28;
    musicAudio.play().catch(() => {});
  }

  function stopMusic() {
    if (!musicAudio) return;
    musicAudio.pause();
    musicAudio.currentTime = 0;
    musicAudio = null;
  }

  function updateMuteButton() {
    muteButton.classList.toggle('is-muted', musicMuted);
    unmutedIcon.hidden = musicMuted;
    mutedIcon.hidden = !musicMuted;
    muteButton.setAttribute('aria-label', musicMuted ? 'Unmute game music' : 'Mute game music');
    muteButton.setAttribute('aria-pressed', String(musicMuted));
  }

  muteButton.addEventListener('click', () => {
    musicMuted = !musicMuted;
    if (musicAudio) musicAudio.volume = musicMuted ? 0 : .28;
    updateMuteButton();
  });

  function renderLives(count) {
    const livesCount = Math.max(0, Number(count) || 0);
    lives.replaceChildren(...Array.from({ length: livesCount }, () => {
      const heart = document.createElement('span');
      heart.className = 'discount-hunt__heart';
      heart.setAttribute('aria-hidden', 'true');
      heart.innerHTML = '<svg viewBox="0 0 32 28" focusable="false"><path d="M16 27C14 24 3 18 2 9 1 4 4 1 8 1c3 0 6 2 8 5 2-3 5-5 8-5 4 0 7 3 6 8-1 9-12 15-14 18Z"/></svg>';
      return heart;
    }));
    lives.setAttribute('aria-label', `${livesCount} ${livesCount === 1 ? 'life' : 'lives'} remaining`);
  }

  function closeDifficultyMenu() {
    difficultyMenu.hidden = true;
    difficultyTrigger.setAttribute('aria-expanded', 'false');
  }

  difficultyTrigger.addEventListener('click', () => {
    const isOpen = difficultyTrigger.getAttribute('aria-expanded') === 'true';
    difficultyMenu.hidden = isOpen;
    difficultyTrigger.setAttribute('aria-expanded', String(!isOpen));
  });
  difficultyMenu.addEventListener('click', (event) => {
    const option = event.target.closest('[data-hunt-difficulty-option]');
    if (!option) return;
    difficulty.value = option.dataset.huntDifficultyOption;
    difficultyLabel.textContent = option.textContent;
    difficultyMenu.querySelectorAll('[data-hunt-difficulty-option]').forEach((item) => item.setAttribute('aria-selected', String(item === option)));
    closeDifficultyMenu();
  });
  document.addEventListener('click', (event) => {
    if (!difficultyTrigger.contains(event.target) && !difficultyMenu.contains(event.target)) closeDifficultyMenu();
  });

  const showError = (message) => { error.textContent = message; error.hidden = !message; };
  const request = (url, requestOptions) => fetch(url, { credentials: 'same-origin', ...requestOptions }).then(async (response) => {
    const payload = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(payload.error || 'Something went wrong.');
    return payload;
  });

  request(api).then((state) => {
    available = state.availableChances;
    chances.textContent = available;
    orders.textContent = state.orderCount;
    spendInput.max = available;
    updateAvailabilityState();
  }).catch((err) => showError(err.message));

  function setVisible(element, visible) {
    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
  }

  function clearBoard() {
    board.replaceChildren();
    board.className = 'discount-hunt__board';
    board.removeAttribute('style');
  }

  async function resetView() {
    // Do not clear the game UI until the server has refunded every unused
    // life. This makes quitting safe even when the player has not made a move.
    if (session) {
      try {
        await abandonSession();
      } catch (err) {
        showError(err.message);
        return;
      }
    }
    cleanupGame();
    cleanupGame = () => {};
    stopMusic();
    panel.hidden = true;
    panel.classList.remove('is-playing');
    result.hidden = true;
    setVisible(games, true);
    setVisible(setup, false);
    setVisible(options, false);
    clearBoard();
    session = null;
    activeLives = 0;
    selectedGame = null;
    startButton.hidden = false;
    startButton.style.display = '';
  }

  function abandonSession() {
    if (!session) return Promise.resolve();
    const abandonedSession = session;
    const livesToRefund = Math.max(0, activeLives);
    return request(`${api}?action=abandon`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ sessionId: abandonedSession.sessionId, livesRemaining: livesToRefund }),
    }).then((payload) => {
      available = payload.availableChances;
      chances.textContent = available;
      spendInput.max = available;
      updateAvailabilityState();
      session = null;
      activeLives = 0;
    });
  }

  function finish(won, rewardPercent) {
    if (!session) return;
    isFinishing = true;
    stopMusic();
    cleanupGame();
    cleanupGame = () => {};
    status.textContent = won ? `You unlocked ${rewardPercent}% off!` : 'This game is over.';
    request(`${api}?action=finish`, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ sessionId: session.sessionId, won, rewardPercent }),
    }).then((payload) => {
      session = null;
      activeLives = 0;
      panel.hidden = true;
      result.hidden = false;
      root.querySelector('[data-hunt-result-heading]').textContent = payload.rewardPercent ? `${payload.rewardPercent}% reward unlocked` : 'Better luck next time';
      root.querySelector('[data-hunt-result-copy]').textContent = payload.message;
      const hasCode = Boolean(payload.discountCode);
      discount.textContent = payload.discountCode || '';
      discount.hidden = !hasCode;
      copyButton.hidden = !hasCode;
      copyButton.style.display = hasCode ? '' : 'none';
      discount.style.display = hasCode ? '' : 'none';
    }).catch((err) => showError(err.message));
  }

  function startConcentration() {
    const symbols = ['🍋','🍊','🍓','🍉','🍍','🫐','🥭','🍏','🍑','🍒','🥝','🍇','🍐','🍌','🥥','🍎','🌿','🟢'];
    const deck = symbols.concat(symbols).sort(() => Math.random() - 0.5);
    const flipped = [];
    let matched = 0;
    let remainingLives = activeLives || session.lives;
    board.className = 'discount-hunt__board discount-hunt__board--concentration';
    board.style.removeProperty('display');
    // Concentration is always a 6 × 6 board (36 tiles). Keep this inline as
    // well as in the stylesheet so theme-editor/global grid rules cannot
    // change it to another column count.
    board.style.display = 'grid';
    board.style.gridTemplateColumns = 'repeat(6, minmax(0, 1fr))';
    board.style.gridAutoFlow = 'row';
    deck.forEach((symbol) => {
      const card = document.createElement('button');
      card.type = 'button';
      card.className = 'discount-hunt__memory-card';
      card.innerHTML = '<span class="discount-hunt__memory-mark">🌿</span><span class="discount-hunt__memory-symbol"></span>';
      card.addEventListener('click', () => {
        if (flipped.length === 2 || card.classList.contains('is-matched') || card.classList.contains('is-open')) return;
        card.classList.add('is-open');
        card.querySelector('.discount-hunt__memory-symbol').textContent = symbol;
        flipped.push({ card, symbol });
        if (flipped.length !== 2) return;
        const [first, second] = flipped;
        if (first.symbol === second.symbol) {
          first.card.classList.add('is-matched');
          second.card.classList.add('is-matched');
          flipped.length = 0;
          matched += 1;
          status.textContent = `${matched} pair${matched === 1 ? '' : 's'} found · ${Math.max(0, 3 - matched)} more for the top reward`;
          if (matched >= 3) finish(true, 15);
          return;
        }
        remainingLives -= 1;
        activeLives = remainingLives;
        renderLives(remainingLives);
        setTimeout(() => {
          first.card.classList.remove('is-open');
          second.card.classList.remove('is-open');
          first.card.querySelector('.discount-hunt__memory-symbol').textContent = '';
          second.card.querySelector('.discount-hunt__memory-symbol').textContent = '';
          flipped.length = 0;
          if (remainingLives <= 0) {
            const reward = Math.min(matched, 3) * 5;
            finish(reward > 0, reward);
          }
        }, 650);
      });
      board.appendChild(card);
    });
    status.textContent = 'Find three pairs to unlock the top reward.';
  }

  function startMinesweeper() {
    const config = { easy: [8, 10, 5], medium: [10, 18, 10], hard: [12, 30, 15] }[difficulty.value];
    const [size, mineCount, reward] = config;
    const total = size * size;
    const mineSet = new Set();
    let firstClick = true;
    let locked = false;
    const revealed = new Set();
    const flagged = new Set();
    const hitMines = new Set();
    board.replaceChildren();
    board.className = `discount-hunt__board discount-hunt__board--minesweeper is-${difficulty.value}`;
    board.style.setProperty('--mine-columns', size);
    const cells = Array.from({ length: total }, () => document.createElement('button'));
    const neighbours = (index) => {
      const row = Math.floor(index / size); const col = index % size; const result = [];
      for (let r = row - 1; r <= row + 1; r += 1) for (let c = col - 1; c <= col + 1; c += 1) {
        if (r >= 0 && r < size && c >= 0 && c < size && (r !== row || c !== col)) result.push(r * size + c);
      }
      return result;
    };
    const adjacent = (index) => neighbours(index).filter((item) => mineSet.has(item)).length;
    const placeMines = (safeIndex) => {
      const blocked = new Set([safeIndex, ...neighbours(safeIndex)]);
      while (mineSet.size < mineCount) {
        const candidate = Math.floor(Math.random() * total);
        if (!blocked.has(candidate)) mineSet.add(candidate);
      }
    };
    const renderCell = (index) => {
      const cell = cells[index];
      const value = cell.firstElementChild;
      const isMine = mineSet.has(index) && (hitMines.has(index) || locked);
      cell.classList.toggle('is-flagged', flagged.has(index));
      cell.classList.toggle('is-revealed', revealed.has(index));
      cell.classList.toggle('is-mine', isMine);
      delete cell.dataset.number;
      if (flagged.has(index)) value.textContent = '⚑';
      else if (isMine) value.textContent = '💣';
      else if (revealed.has(index)) {
        const count = adjacent(index);
        value.textContent = count || '·';
        cell.dataset.number = count;
      } else value.textContent = '';
    };
    const revealAll = () => mineSet.forEach((index) => { hitMines.add(index); renderCell(index); });
    const reveal = (index) => {
      if (flagged.has(index) || revealed.has(index)) return;
      revealed.add(index); renderCell(index);
      if (adjacent(index) === 0) neighbours(index).forEach((item) => { if (!mineSet.has(item)) reveal(item); });
    };
    cells.forEach((cell, index) => {
      cell.type = 'button'; cell.className = 'discount-hunt__mine-cell'; cell.setAttribute('aria-label', `Minesweeper cell ${index + 1}`);
      const value = document.createElement('span'); value.className = 'discount-hunt__mine-value'; value.setAttribute('aria-hidden', 'true'); cell.appendChild(value);
      cell.addEventListener('click', () => {
        if (locked || flagged.has(index) || revealed.has(index)) return;
        if (firstClick) { placeMines(index); firstClick = false; }
        if (mineSet.has(index)) {
          if (hitMines.has(index)) return;
          hitMines.add(index);
          activeLives -= 1;
          renderLives(activeLives);
          renderCell(index);
          if (activeLives <= 0) {
            locked = true;
            revealAll();
            finish(false, 0);
          } else {
            status.textContent = `Mine hit. Continue carefully — ${activeLives} life${activeLives === 1 ? '' : 's'} remaining.`;
          }
          return;
        }
        reveal(index);
        if (revealed.size >= total - mineCount) finish(true, reward);
      });
      cell.addEventListener('contextmenu', (event) => { event.preventDefault(); if (firstClick || revealed.has(index)) return; if (flagged.has(index)) flagged.delete(index); else if (flagged.size < mineCount) flagged.add(index); renderCell(index); });
      board.appendChild(cell);
    });
    status.textContent = `${difficulty.options[difficulty.selectedIndex].text} · left-click to reveal, right-click to flag.`;
  }

  function chooseGame(game) {
    selectedGame = game; showError(''); result.hidden = true; setVisible(games, false); setVisible(setup, true); setVisible(options, true); panel.hidden = false; clearBoard();
    const isMinesweeper = game === 'minesweeper';
    const usesDifficulty = isMinesweeper;
    difficultyWrap.hidden = !usesDifficulty;
    difficultyWrap.style.display = usesDifficulty ? '' : 'none';
    roundsWrap.hidden = true;
    roundsWrap.style.display = 'none';
    title.textContent = game === 'concentration' ? 'Concentration' : 'Minesweeper';
    description.textContent = game === 'concentration' ? 'Find all matching ingredient pairs.' : 'Clear the board without hitting a mine.';
    gameIcon.textContent = game === 'concentration' ? '🍋' : '💣';
    renderLives(available); status.textContent = 'Your chance is used only after the game starts.'; startButton.hidden = false; startButton.style.display = '';
  }

  function startGame() {
    const spend = Number(spendInput.value);
    if (!selectedGame || !Number.isInteger(spend) || spend < 1 || spend > available) { showError('Not enough chances remaining.'); return; }
    showError('');
    startMusic(selectedGame);
    request(`${api}?action=start`, { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ game: selectedGame, spend }) }).then((data) => {
      session = data; isFinishing = false; available = data.availableChances; chances.textContent = available; spendInput.max = available; updateAvailabilityState(); setup.hidden = true; setVisible(options, false); startButton.hidden = true; startButton.style.display = 'none'; renderLives(data.lives); panel.classList.add('is-playing'); updateMuteButton();
      activeLives = data.lives;
      if (selectedGame === 'concentration') startConcentration(); else startMinesweeper();
    }).catch((err) => { stopMusic(); showError(err.message); });
  }

  function abandonSessionOnExit() {
    if (!session || isFinishing) return;
    const body = JSON.stringify({ sessionId: session.sessionId, livesRemaining: Math.max(0, activeLives) });
    const endpoint = `${api}?action=abandon`;
    const payload = new Blob([body], { type: 'application/json' });
    if (!navigator.sendBeacon || !navigator.sendBeacon(endpoint, payload)) {
      fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'content-type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
    session = null;
  }

  games.addEventListener('click', (event) => { const button = event.target.closest('[data-hunt-game]'); if (button) chooseGame(button.dataset.huntGame); });
  root.querySelector('[data-hunt-back]').addEventListener('click', resetView);
  startButton.addEventListener('click', startGame);
  copyButton.addEventListener('click', () => navigator.clipboard.writeText(discount.textContent));
  againButton.addEventListener('click', resetView);
  spendDecrease.addEventListener('click', () => { spendInput.value = Math.max(1, Number(spendInput.value || 1) - 1); spendInput.dispatchEvent(new Event('change')); });
  spendIncrease.addEventListener('click', () => { spendInput.value = Math.min(available || Number(spendInput.max) || 1, Number(spendInput.value || 1) + 1); spendInput.dispatchEvent(new Event('change')); });
  window.addEventListener('pagehide', abandonSessionOnExit);
})();
